import { put } from 'redux-saga/effects';
import { LoyaltyService } from '../../../services/Loyalty';
import {
  ILoyaltyRewardsResponse,
  ILoyaltyGoalResponse,
  ILoyaltyHistoryResponse,
  Types,
  ILoyaltyProductResponse,
  ILoyaltyProductSimulateResponse,
  ILoyaltyProductListToSend,
  ILoyaltyWithdrawResponse,
  ILoyaltySendWithdrawResponse,
  ILoyaltySendWithdrawBody
} from './types';
import {
  loadLoyaltyRewardsFailure,
  loadLoyaltyRewardsSuccess,
  loadLoyaltyGoalSuccess,
  loadLoyaltyGoalFailure,
  loadLoyaltyHistorySuccess,
  loadLoyaltyHistoryFailure,
  loadLoyaltyProductSuccess,
  loadLoyaltyProductFailure,
  loadLoyaltyProductSimulateSuccess,
  loadLoyaltyProductSimulateFailure,
  loadLoyaltyWithdrawSuccess,
  loadLoyaltyWithdrawFailure,
  loadLoyaltySendWithdrawSuccess,
  loadLoyaltySendWithdrawFailure
} from './actions';
import { AxiosError } from 'axios';

interface ILoadLoyaltyDataParams {
  payload: {
    loyaltyCustomers: string[];
  };
  type: Types;
}

interface ILoadLoyaltySendWithdrawParams {
  payload: {
    loyaltyCustomers: string[];
    requestBody: ILoyaltySendWithdrawBody;
  };
  type: Types;
}
interface ILoadLoyaltySendProductParams {
  payload: {
    loyaltyCustomers: string;
    productList: ILoyaltyProductListToSend[];
  };
  type: Types;
}

interface ILoadLoyaltyProductParams {
  payload: {
    sku: string;
  };
  type: Types;
}

export function* loadLoyaltyRewardsSaga(params: ILoadLoyaltyDataParams) {
  const loyaltyService = new LoyaltyService();
  try {
    const { loyaltyCustomers } = params.payload;

    const rewardsResponse: ILoyaltyRewardsResponse =
      yield loyaltyService.loadLoyaltyRewards(loyaltyCustomers);

    yield put(loadLoyaltyRewardsSuccess(rewardsResponse));
  } catch (err) {
    yield put(loadLoyaltyRewardsFailure(err as AxiosError));
  }
}

export function* loadLoyaltyGoalSaga(params: ILoadLoyaltyDataParams) {
  const loyaltyService = new LoyaltyService();
  try {
    const { loyaltyCustomers } = params.payload;

    const goalResponse: ILoyaltyGoalResponse =
      yield loyaltyService.loadLoyaltyGoal(loyaltyCustomers);

    yield put(loadLoyaltyGoalSuccess(goalResponse));
  } catch (err) {
    yield put(loadLoyaltyGoalFailure(err as AxiosError));
  }
}

export function* loadLoyaltyProductSaga(params: ILoadLoyaltyProductParams) {
  const loyaltyService = new LoyaltyService();
  try {
    const productResponse: ILoyaltyProductResponse =
      yield loyaltyService.loadLoyaltyProduct(params.payload.sku);

    yield put(loadLoyaltyProductSuccess(productResponse));
  } catch (err) {
    yield put(loadLoyaltyProductFailure(err as AxiosError));
  }
}
export function* loadLoyaltyProductSimulateSaga(
  params: ILoadLoyaltySendProductParams
) {
  const loyaltyService = new LoyaltyService();
  try {
    const productResponse: ILoyaltyProductSimulateResponse =
      yield loyaltyService.loadLoyaltyProductSimulate(
        params.payload.loyaltyCustomers,
        params.payload.productList
      );
    yield put(loadLoyaltyProductSimulateSuccess(productResponse));
  } catch (err) {
    yield put(loadLoyaltyProductSimulateFailure(err as AxiosError));
  }
}

export function* loadLoyaltyHistorySaga(params: ILoadLoyaltyDataParams) {
  const loyaltyService = new LoyaltyService();
  try {
    const { loyaltyCustomers } = params.payload;

    const historyResponse: ILoyaltyHistoryResponse =
      yield loyaltyService.loadLoyaltyHistory(loyaltyCustomers);

    yield put(loadLoyaltyHistorySuccess(historyResponse));
  } catch (err) {
    yield put(loadLoyaltyHistoryFailure(err as AxiosError));
  }
}

export function* loadLoyaltyWithdrawSaga() {
  const loyaltyService = new LoyaltyService();
  try {
    const withdrawResponse: ILoyaltyWithdrawResponse =
      yield loyaltyService.loadLoyaltyWithdraw();

    yield put(loadLoyaltyWithdrawSuccess(withdrawResponse));
  } catch (err) {
    yield put(loadLoyaltyWithdrawFailure(err as AxiosError));
  }
}

export function* loadLoyaltySendWithdrawSaga(
  params: ILoadLoyaltySendWithdrawParams
) {
  const loyaltyService = new LoyaltyService();
  try {
    const productResponse: ILoyaltySendWithdrawResponse =
      yield loyaltyService.loadLoyaltySendWithdraw(
        params.payload.loyaltyCustomers,
        params.payload.requestBody
      );
    yield put(loadLoyaltySendWithdrawSuccess(productResponse));
  } catch (err) {
    yield put(loadLoyaltySendWithdrawFailure(err as AxiosError));
  }
}
